import * as R from 'ramda'
import { Typography } from '@mui/material'
import { IMessage, Message } from '@weblite/ts-action/message'
import { t } from '$i18n'

function SenderNameTypography({ children: body }: { children: string }) {
  return (
    <Typography
      variant="subtitle4"
      color="secondary"
      sx={{ display: 'block', lineHeight: '14px' }}
      noWrap
    >
      {body}
    </Typography>
  )
}

const MessageTypeNameMap: Record<IMessage['type'], string> = {
  IMAGE: t('message.IMAGE'),
  TEXT: t('forward.text'),
  AUDIO: t('message.AUDIO'),
  FILE: t('message.FILE'),
  WAPP: t('forward.wapp'),
  VOICE: t('message.VOICE'),
  VIDEO: t('message.VIDEO'),
  CONTACT: t('message.CONTACT'),
  CALL: '',
  EVENT: '',
}

export function ForwardStatus({ messages }: { messages: Message[] }) {
  const hasSameType = R.length(R.uniq(R.pluck('type', messages))) === 1
  const messageTypeName = MessageTypeNameMap[messages[0].type]
  const status = hasSameType
    ? t('forward.forwardSameMessages')(messages.length, messageTypeName)
    : t('forward.forward')(messages.length)

  return <SenderNameTypography>{status}</SenderNameTypography>
}
